import { Component, OnInit, ViewChild, ElementRef, OnDestroy, AfterViewInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { trigger, style, transition, animate } from '@angular/animations';

import { Subscription, throwError, fromEvent } from 'rxjs';
import { map, debounceTime, distinctUntilChanged, catchError, finalize } from 'rxjs/operators';

import { StringUtil } from 'src/app/core/framework/utils/string-util';
import { Paciente } from 'src/app/homecare/paciente/paciente.model';
import { PacienteService } from 'src/app/homecare/paciente/paciente.service';
import { PacienteFilter } from 'src/app/homecare/paciente/paciente-filter';
import { Status } from '../../default.model';
import { ErrorHandlerService } from '../../error-handler.service';
import { ListaResultset } from 'src/app/core/list/lista-resultset.interface';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-topbar-search',
  templateUrl: './topbar-search.component.html',
  styleUrls: ['./topbar-search.component.css'],
  animations: [
    trigger('panelInOut', [
        // transition('void => *', [
        //     style({width: '160px'}),
        //     animate(200)
        // ]),
        transition('* => void', [
            animate(200, 
              style({width: '0px'}),
              // style({transform: 'translateX(50%)'})
            )
        ])
    ])
  ]
})
export class TopbarSearchComponent implements OnInit, AfterViewInit, OnDestroy {

  private milisegundosCampoVisivel = 3000;
  private quantidadeDeResultados   = environment.pesquisa_paciente_topbar_max_size;

  public caixaDePesquisaVisivel = false;

  private setTimeoutEsconder = null;

  public valor = '';
  @ViewChild('caixaDePesquisa') inputBuscaRapida: ElementRef;
  private subscriptionBuscaRapida: Subscription;

  public state: 'loading' | 'not-found' | '';

  public pacientes: Paciente[] = [];

  public activeIndex = 0;

  constructor(
    private pacienteService: PacienteService,
    private router: Router,
    private errorHandlerService: ErrorHandlerService
  ) { }

  @HostListener('document:keydown.control.space', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    this.toggleCaixaDePesquisa();
  }

  @HostListener('document:keydown.esc', ['$event']) onKeydownEscHandler(event: KeyboardEvent) {
    this.limparEFecharCaixaDePesquisa();
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    this.esconderCaixaDePesquisa();
    this.destruirSubscriptionInputBuscaRapida();
  }

  destruirSubscriptionInputBuscaRapida(): void {
    if (this.subscriptionBuscaRapida) {
      this.subscriptionBuscaRapida.unsubscribe();
    }    
  }

  public abrirPaciente(paciente: Paciente): void {
    this.router.navigate(['/homecare/sumario-paciente', paciente.id]);
    setTimeout(() => {
      this.esconderCaixaDePesquisa();
    }, 280);
  }

  private criaSubscriptionInputBuscaRapida() {
    if ( !this.inputBuscaRapida || !this.inputBuscaRapida.nativeElement ) {
      return;
    }

    const palavra$ = fromEvent<any>(this.inputBuscaRapida.nativeElement, 'keyup')
                    .pipe(
                      map(event => event.target.value),
                        // startWith(''),
                        debounceTime(environment.default_debounce_time),
                        distinctUntilChanged()
                    );    

    this.subscriptionBuscaRapida = palavra$.subscribe(
        _palavra => {
          this.pesquisarPaciente(_palavra);
        }
    );                    
  }


  pesquisarPaciente(nome: string): void {
    if ( !nome || !nome.trim() ) {
      return;
    }

    this.state = 'loading';
    this.pacientes = [];
    const filtro: PacienteFilter = {
      status: Status.ATIVO,
      size: this.quantidadeDeResultados
    }

    if ( StringUtil.comecaComNumero(nome) ) {
      filtro.cpf = nome;
    }
    else {
      filtro.nome = nome;
    }


    this.pacienteService
        .listarSomentePacientesInternos(filtro)
        .pipe(
          catchError( err => {
            this.state = '';
            this.errorHandlerService.handle(err);
            return throwError(err);
          })
          , map((result: ListaResultset<Paciente>) => {
            this.pacientes = result.content;
          })
          , finalize(() => {
            this.state = ( this.pacientes.length === 0 ? 'not-found' : '' )
          })
        )
        .subscribe();
  }



  /* =-=-=-=-=-=-=-=-=-=-=-=-=-=-
      INPUT CAIXA DE PESQUISA
  =-=-=-=-=-=-=-=-=-=-=-=-=-=-   */

  public onKeyUpCaixaDePesquisa(): void {
    this.state = '';
  }

  public toggleCaixaDePesquisa(): void {
    if ( this.caixaDePesquisaVisivel ) {
      this.limparEFecharCaixaDePesquisa();
    }
    else {
      this.abrirCaixaDePesquisa();
    }
  }

  public abrirCaixaDePesquisa(): void {
    this.caixaDePesquisaVisivel = true;
    this.activeIndex = 0;

    if ( !this.valor.trim() ) {
      this.state = '';
    }

    setTimeout(() => {
      if ( this.valor ) {
        // @ts-ignore
        document.getElementById('caixaDePesquisa').select()
      }
      else {
        document.getElementById('caixaDePesquisa').focus();
      }
      this.criaSubscriptionInputBuscaRapida();
    }, 150);
  }

  public esconderCaixaDePesquisa(): void {
    this.destruirSubscriptionInputBuscaRapida();
    this.state = '';
    this.caixaDePesquisaVisivel = false;
    this.pacientes = [];
    this.activeIndex = 0;
  }

  public onBlurCaixaDePesquisa(): void {
    if ( this.state !== 'loading' ) {
      this.setTimeoutEsconder = setTimeout(() => {
        this.esconderCaixaDePesquisa();
      }, 

      this.pacientes.length ? (2 * this.milisegundosCampoVisivel)
                              : this.milisegundosCampoVisivel
      );
    }
  }

  public onFocusCaixaDePesquisa(): void {
    if ( this.setTimeoutEsconder ) {
      clearTimeout(this.setTimeoutEsconder);
    }
  }

  private limparEFecharCaixaDePesquisa(): void {
    this.valor = '';
    this.esconderCaixaDePesquisa();
  }

  public onChangeCaixaDePesquisa(): void {
    if ( !this.valor.trim() ) {
      this.pacientes = [];
    }
  }

  public onKeyUpEnter(): void {
    try {
      if ( this.pacientes.length === 1 ) {
        this.abrirPaciente(this.pacientes[0]);
        return;
      }
      
      if ( this.activeIndex > 0 ) {
        const paciente = this.pacientes[this.activeIndex-1];
        if ( paciente ) {
          this.abrirPaciente(paciente);
        }
      }
    }
    catch(e) {
      console.error(e);
    }
  }

  public onKeyUpUp(): void {
    if ( this.activeIndex > 1 ) {
      this.activeIndex--;
    }
  }

  public onKeyUpDown(): void {
    if ( this.activeIndex < this.pacientes.length ) {
      this.activeIndex++;
    }
  }

}
